import React__default from 'react';
import styled from 'styled-components';
import AtlasButton from '../components/AtlasButton/AtlasButton.js';

const MoreIcon = () => {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M5 14c1.10457 0 2-.8954 2-2s-.89543-2-2-2-2 .8954-2 2 .89543 2 2 2Zm7 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm7 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Z",
    fill: "currentColor"
  }));
};
MoreIcon.displayName = "MoreIcon";
styled.svg.withConfig({
  displayName: "MicroHeaderMenu__SVG",
  componentId: "sc-2w4062-0"
})(["display:block;user-select:none;overflow:visible;"]);

/**
 * MicroHeaderMenu displays a contextual menu that renders
 * a dropdown or listbox component, the arguments for which are passed into MicroHeader
 * as properties of the object in the `menuItems` prop.
 *
 */
const MicroHeaderMenu = ({
  menuItems,
  children,
  actionHandler
}) => {
  console.warn('Microheader is deprecated. Use the v1.1 layout for Getting Started screens instead. See: https://www.fuegokit.design/react-storybook/?path=/story/patterns-getting-started-page--getting-started-page-growth');
  return /*#__PURE__*/React__default.createElement(AtlasButton, {
    as: "button",
    onClick: () => alert('Your dropdown or contextual menu solution of choice goes here.'),
    "data-testid": "microheader-menu-btn",
    "aria-label": "More",
    sx: {
      paddingRight: '4px',
      paddingLeft: '4px'
    }
  }, /*#__PURE__*/React__default.createElement(MoreIcon, null), children);
};
MicroHeaderMenu.displayName = "MicroHeaderMenu";
MicroHeaderMenu.displayName = 'MicroHeaderMenu';
var MicroHeaderMenu$1 = MicroHeaderMenu;

export { MicroHeaderMenu$1 as default };
